<template>
    <el-dialog v-dialogDrag class="dialog" width="500px" :visible.sync="dialogVisible" v-loading="dialoading" :close-on-click-modal="false"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                选择一个分配的角色
            </div>
        </div>
        <div class="dialog_body">
            <el-table
                    ref="treeTable"
                    :data="dataList"
                    height="400"
                    style="width: 100%;margin-top: 10px"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    border
                    @row-click="rowClick">
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="角色名称"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="code"
                        label="角色编码">
                </el-table-column>
<!--                <el-table-column-->
<!--                        label="操作">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-button-->
<!--                                @click="selRow(scope.row)"-->
<!--                                type="primary"-->
<!--                                size="small">-->
<!--                            选择-->
<!--                        </el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
            <div style="text-align: center;padding-top: 10px">
                <el-button type="warning" @click="close">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "selRole",
        props: ['formData', 'loading'],
        data() {
            return {
                dialogVisible: true,
                dialoading: false,
                dataList: [],
                roleData: {},
                selUser: [],
            }
        },
        async created() {
            await this.getRoleList();
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog')
            },

            async getRoleList() {
                this.dialoading = true;
                let param = {

                }
                const data = await this.$sqlOpt.role.getTableList(param)
                this.dialoading = false;
                if (data.code === '1') {
                    this.dataList = data.data.list;
                }
            },
            selRow() {
                // this.$emit("checkRow", row);
            },
            //点击列表
            rowClick(row) {
                this.roleData = row;
            },
            submit() {
                if(this.roleData === null || JSON.stringify(this.roleData) === '{}'){
                    this.$message({message: '请先选择一个角色', type: 'error'});
                }else{
                    this.$emit("doCreate", this.roleData);
                }

            },

        },
    }
</script>

<style scoped>

    .dialog /deep/ .el-dialog__header {
        padding: 0;
        text-align: center;
    }

    .dialog /deep/ .el-dialog__headerbtn {
        top: 8px;
        right: 10px
    }

    .dialog /deep/ .el-dialog__headerbtn .el-dialog__close {
        color: #FFF;
    }


    .dialog /deep/ .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 0px;
    }

    .dialog /deep/ .el-table .el-table__cell {
        padding: 5px 0;
    }

    .dialog .dialog_title {
        background-color: rgba(28, 136, 201, 0.6);
        padding: 5px 10px 5px;
    }

    .dialog .dialog_body {
        padding: 10px;
        max-height: 580px;
        border-left: 10px solid rgba(28, 136, 201, 0.6);
        border-right: 10px solid rgba(28, 136, 201, 0.6);
        border-bottom: 10px solid rgba(28, 136, 201, 0.6);
        background-color: rgba(193, 245, 236, 0.15);
    }

    .dialog /deep/ .el-table__body tr.current-row > td.el-table__cell {
        background-color: #66c4f6;
    }
</style>
